import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw16px =
  'M9.933 1.277h-5.11a2.678 2.678 0 0 0-2.68 2.67v8.18a2.678 2.678 0 0 0 2.68 2.67h6.35a2.678 2.678 0 0 0 2.68-2.67V5.2Zm2.42 10.85a1.18 1.18 0 0 1-1.18 1.17h-6.35a1.18 1.18 0 0 1-1.18-1.17v-8.18a1.18 1.18 0 0 1 1.18-1.17h4.42v3.11h3.11ZM7.753 8v3a.75.75 0 0 1-.47.69.706.706 0 0 1-.28.06.749.749 0 0 1-.53-.22l-1.5-1.5a.737.737 0 0 1 0-1.06l1.5-1.5a.72.72 0 0 1 .81-.16.75.75 0 0 1 .47.69Zm3.28 2.03-1.5 1.5a.786.786 0 0 1-.53.22.717.717 0 0 1-.29-.06.741.741 0 0 1-.46-.69V8a.751.751 0 0 1 1.28-.53l1.5 1.5a.754.754 0 0 1 0 1.057Z';
const draw24px =
  'M15,1.9h0l-7.89,0A3.76,3.76,0,0,0,3.31,5.61l0,12.74A3.77,3.77,0,0,0,7,22.11l9.9,0a3.75,3.75,0,0,0,3.76-3.74l0-10.73Zm4.22,16.49a2.24,2.24,0,0,1-2.25,2.24l-9.9,0a2.27,2.27,0,0,1-2.25-2.26l0-12.74A2.25,2.25,0,0,1,7.07,3.37l6.89,0V8.65h5.26Zm-1.59-2.92a.76.76,0,0,1-.22.54l-2.65,2.54a.73.73,0,0,1-.52.21.79.79,0,0,1-.54-.24.76.76,0,0,1,0-1.06L15,16.22l-6,0,1.28,1.26a.75.75,0,0,1,0,1.06.71.71,0,0,1-.54.22.75.75,0,0,1-.52-.21L6.64,16a.74.74,0,0,1-.17-.25.73.73,0,0,1,0-.58.85.85,0,0,1,.17-.25l2.64-2.53a.75.75,0,1,1,1,1.09L9,14.7l6,0-1.29-1.25a.79.79,0,0,1,0-1.07.76.76,0,0,1,1.06,0l2.63,2.53A.77.77,0,0,1,17.59,15.47Z';

const icons: IconVariations = {
  _16: { d: draw16px, viewBox: VIEWBOXES._16 },
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const DocumentArrowLeftRightIcon = forwardRef<
  SVGSVGElement,
  ComponentProps<typeof Icon>
>(generateRenderedIcon(icons, 'documentArrowLeftRight')) as IconWithRender;

DocumentArrowLeftRightIcon.displayName = 'DocumentArrowLeftRightIcon';
DocumentArrowLeftRightIcon.propTypes = Icon.propTypes;
DocumentArrowLeftRightIcon.renderIcon = (props) => (
  <DocumentArrowLeftRightIcon {...props} />
);
export default DocumentArrowLeftRightIcon;
